module.exports = __webpack_public_path__ + "img/welcomes-minip-white.a6a307b9.png";